<!-- Base.ActionButtons.vue (client-lms) -->
<template>
  <div class="lms_action_buttons">
    <LmsBase.Button color="gray" size="48" @click="onCancel">{{ cancelText }}</LmsBase.Button>
    <LmsBase.Button color="black" size="48" @click="onConfirm">{{ confirmText }}</LmsBase.Button>
  </div>
</template>

<script setup lang="ts">
import { LmsBase } from "@/common/base-components/BaseFactory";

defineProps({
  cancelText: { type: String, default: "취소" },
  confirmText: { type: String, default: "등록하기" },
});

const emit = defineEmits<{
  (e: "cancel"): void;
  (e: "confirm"): void;
}>();

const onCancel = () => emit("cancel");
const onConfirm = () => emit("confirm");
</script>
